import { isNil } from 'shared/src/utils';
import { useGoodsBasic } from '../../../queries/useGoodsBasic';
import { isDeliveryTypeIsToday } from '../../../utils/isDeliveryTypeIsToday';
import { isSalesMethodIsPreOrder } from '../../../utils/isSalesMethodIsPreOrder';
import { PreOrderDeliverySection } from './PreOrderDeliverySection';
import { StandardDeliverySection } from './StandardDeliverySection';
import { TodayDeliverySection } from './TodayDeliverySection';

export const DeliverySection = () => {
  const { data: goodsBasic } = useGoodsBasic();

  if (isNil(goodsBasic)) {
    return null;
  }

  if (isSalesMethodIsPreOrder(goodsBasic)) {
    return <PreOrderDeliverySection />;
  }

  if (isDeliveryTypeIsToday(goodsBasic)) {
    return <TodayDeliverySection />;
  }

  return <StandardDeliverySection />;
};
